import { render, staticRenderFns } from "./DonutChart50.vue?vue&type=template&id=4e3f661c&scoped=true"
import script from "./DonutChart50.vue?vue&type=script&lang=js"
export * from "./DonutChart50.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3f661c",
  null
  
)

export default component.exports